export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/mezzoforte-icon.svg?baf7ed6b2a8c2e326ac2f66757fe3fa1";